/**
 * MDB Lightbox — אתחול מפורש לגלריית תמונות בעסק (אחרי mdb.min.js).
 * https://mdbootstrap.com/docs/standard/components/lightbox/
 */
(function () {
  "use strict";

  function getMdbLightboxClass() {
    var m = window.mdb;
    if (!m) {
      return null;
    }
    if (typeof m.Lightbox === "function") {
      return m.Lightbox;
    }
    var d = m.default;
    if (d && typeof d.Lightbox === "function") {
      return d.Lightbox;
    }
    return null;
  }

  function initBusinessPhotosLightbox() {
    var LightboxClass = getMdbLightboxClass();
    if (!LightboxClass) {
      return;
    }

    var list = document.querySelectorAll(".br-photos__lightbox.lightbox[data-mdb-lightbox-init]");
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      try {
        if (typeof LightboxClass.getOrCreateInstance === "function") {
          LightboxClass.getOrCreateInstance(el);
          continue;
        }
        var existing =
          typeof LightboxClass.getInstance === "function" ? LightboxClass.getInstance(el) : null;
        if (existing) {
          continue;
        }
        new LightboxClass(el);
      } catch (err) {
        console.error("[business-sites] Lightbox", err);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBusinessPhotosLightbox, { once: true });
  } else {
    initBusinessPhotosLightbox();
  }
})();
